import { render, staticRenderFns } from "./LogoutMenu.vue?vue&type=template&id=1e21b4b7"
import script from "./LogoutMenu.vue?vue&type=script&lang=js"
export * from "./LogoutMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports